<div class="error-dialog">
  <div class="error-dialog-header" 
       [class.error]="data.icon === 'error'" 
       [class.warning]="data.icon === 'warning'"
       [class.info]="data.icon === 'info'">
    <mat-icon *ngIf="data.icon">{{ data.icon }}</mat-icon>
    <h2 mat-dialog-title>{{ data.title || 'Error' }}</h2>
  </div>
  
  <mat-dialog-content>
    <p class="error-message">{{ data.message }}</p>
    <ul *ngIf="data.items?.length" class="error-items">
      <li *ngFor="let item of data.items">{{ item }}</li>
    </ul>
    <p *ngIf="data.details" class="error-details">{{ data.details }}</p>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button 
      *ngIf="data.showCancelButton" 
      mat-button 
      (click)="onCancel()">
      {{ data.cancelButtonText || 'Cancel' }}
    </button>
    <button 
      mat-raised-button 
      [color]="data.icon === 'error' ? 'warn' : 'primary'" 
      (click)="onConfirm()">
      {{ data.confirmButtonText || 'OK' }}
    </button>
  </mat-dialog-actions>
</div>